import React from "react";

function TextWebComponent(props) {
  let {
    alignment,
    bold,
    font,
    fontSize,
    italics,
    text,
    textColor,
    underline,
  } = props;
  // console.log(text);
  const textAlign = ["left", "center", "right"][alignment];
  const parsedText = text.replace(/\\n/g, "\n");

  return (
    <div
      style={{
        fontSize,
        color: textColor,
        textDecoration: `${!!underline ? "underline" : ""}`,
        fontWeight: `${!!bold ? "bold" : ""}`,
        fontStyle: `${!!italics ? "italic" : ""}`,
        fontFamily: `${!!font ? font : ""}`,
        textAlign,
        wordWrap: "break-word",
        position: "relative",
        padding: "5px",
      }}
    >
      {parsedText.split("\n").map((item, key) => {
        return (
          <React.Fragment key={key}>
            {item}
            <br />
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default TextWebComponent;
